<div id="incidents">
    <h1>
        @if (incidents().length) {
            Ongoing incidents
        }
    </h1>
    @for (incident of incidents(); track incident.id) {
        <app-incident [incident]="incident"></app-incident>
    }
</div>
